var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-time"},[(_vm.$mq === 'mobile')?_c('header-mobile-page',{attrs:{"label":_vm.child.name}}):_vm._e(),_c('screen-time-management',{attrs:{"childId":_vm.childId,"show":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }